import {Component} from "react";
import * as React from "react";
import {Icon} from "office-ui-fabric-react";
import {Link} from "react-router-dom";

export interface LinkCardProps
{
    iconName: string;
    title: string;
    description: string;
    to: string;
    disabled?: boolean;
}

interface LinkCardState
{
}

export default class LinkCard extends Component<LinkCardProps,LinkCardState>
{

    constructor(props: Readonly<LinkCardProps>) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
    }



    public render() {

        let Component: any = Link;
        let className: string  = "link-card";
        
        if(this.props.disabled)
        {
            Component = "div";
            className += " link-card--disabled"
        }
        
        return (
            <Component className={className} to={this.props.to}>
                <Icon iconName={this.props.iconName}/>
                <span className={"link-card__title"}>{this.props.title}</span>
                <span className={"link-card__description"}>{this.props.description}</span>
            </Component>
        );
    }
}